import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ReportPMFinancialState {
  collectionPMFinancial: any[];
  paymentPMFinancial: any[];
  balancePMFinancial: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: ReportPMFinancialState = {
  collectionPMFinancial: [],
  paymentPMFinancial: [],
  balancePMFinancial: [],
  isLoading: false,
  error: null,
};

const reportPMFinancialSlice = createSlice({
  name: 'reportPMFinancial',
  initialState,
  reducers: {
    setCollectionPMFinancial: (state, action: PayloadAction<any[]>) => {
      state.collectionPMFinancial = action.payload;
      state.isLoading = false;
      state.error = null;
    },

    setPaymentPMFinancial: (state, action: PayloadAction<any[]>) => {
      state.paymentPMFinancial = action.payload;
      state.isLoading = false;
      state.error = null;
    },

    setBalancePMFinancial: (state, action: PayloadAction<any[]>) => {
      state.balancePMFinancial = action.payload;
      state.isLoading = false;
      state.error = null;
    },

    setReportPMFinancialLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },

    setReportPMFinancialError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  setCollectionPMFinancial,
  setPaymentPMFinancial,
  setBalancePMFinancial,
  setReportPMFinancialLoading,
  setReportPMFinancialError,
} = reportPMFinancialSlice.actions;

export default reportPMFinancialSlice.reducer;
